export type WorkTaskModel = {
  id: string;
  jobId: string;
  jobIdBase64: string | null;

  name: string;
  description: string | null;
  linkName: string | null;
  linkUrl: string | null;
  isDone: boolean;
  isAfterStartDate: boolean;
  noOfDays: number | null;
  timeBudget: number;
  duration: number;
  order: number;
  assignedByUserId: string | null;
  assignedUserId: string | null;
  assignedUser: WorkTaskUser | null;
  jobTaskAssignees?: JobTaskAssignee[];
  createdAt: string;
  dueDate: string;
  templateId: string | null;
  listOfAssignees: string[] | null;
  status: Status | null;
  statusId: string | null;
  subStatus: SubStatus | null;
  subStatusId: string | null;
};

export type UpdateWorkTaskModel = {
  description?: string | null;
  name?: string;
  statusId?: string | null;
  subStatusId?: string | null;
  id?: string;
  isAfterStartDate?: boolean | null;
  noOfDays?: number | null;
  dueDate?: string | null;
  jobId?: string | null;
};

export type JobTaskAssignee = {
  id: string;
  assignedUserId: string;
  assignedUser: WorkTaskUser;
};

type WorkTaskUser = {
  id: string;
  userProfile: {
    firstName: string;
    middleName: string;
    lastName: string;
    color: string;
  };
};

export const toUpdateWorkTaskModel = (
  workTask: WorkTaskModel,
  changes: Partial<UpdateWorkTaskModel> = {},
): UpdateWorkTaskModel => {
  const hasChange = (key: keyof UpdateWorkTaskModel): boolean => {
    return Object.prototype.hasOwnProperty.call(changes, key);
  };

  return {
    id: workTask.id,
    description: hasChange("description")
      ? changes.description
      : workTask.description,
    name: hasChange("name") ? changes.name : workTask.name,
    statusId: hasChange("statusId") ? changes.statusId : workTask.statusId,
    subStatusId: hasChange("subStatusId")
      ? changes.subStatusId
      : workTask.subStatusId,
    dueDate: hasChange("dueDate") ? changes.dueDate : workTask.dueDate,
    jobId: workTask.jobId,
  };
};

type Status = {
  name: string;
  color: string;
  order: number;
  serviceId: string;
  workTypeStatusId: string;
  workTypeStatus: string | null;
  countWork: number;
  id: string;
  relayId: string | null;
};

type SubStatus = {
  subStatus: string;
  serviceStatusId: string;
  worktypeSubStatusId: string;
  workTypeSubStatus: string | null;
  id: string;
  relayId: string | null;
  createdAt: string;
};
